import type { SavedCallOrder } from '@/domain/WorkspaceForex/savedProducts/order/SavedCallOrder.ts';
import type { CallOrder } from '@/store/orders/call/state.ts';

export const mapToCallOrder = (savedTile: SavedCallOrder): CallOrder => {
  return {
    ...savedTile,
    properties: {
      ...savedTile.properties,
    },
  };
};
